export enum AiChatRouteSource {
	DATASETS = 'datamanager.connected.datasets',
	GENIE = 'genie',
	ROUTINE_RUN = 'routines.run',
	SHARED_CHAT = 'shared-chat',
	SHARED_ARTIFACT = 'shared-artifact',
}

// Genie panel and launcher host classes (styles/popups.less); see aiChatService `genieLayer`.
export enum GenieLayer {
	ABOVE_POPUPS = 'genie--above-popups',
	BELOW_POPUPS = 'genie--below-popups',
}

// `entryPoint` of the build-databoard `AI_BOT_PROMPT_SUBMITTED` event
export enum GenieBuildBoardEntryPoint {
	CREATE_WITH_AI = 'create_with_ai_button',
	COMPLETE_WITH_AI = 'complete_with_ai_button',
	POPULATE_PLACEHOLDER = 'populate_with_ai_link',
}

// `entryPoint` of the Analyze-with-Genie `AI_BOT_PROMPT_SUBMITTED` event
export enum GenieAnalyzeEntryPoint {
	ANALYZE_BUTTON = 'analyze_button',
	PERFORMANCE_INDICATOR = 'performance_indicator',
}

// `CALL_INITIATED` origins, one per Genie surface that offers Book a call
export enum GenieBookACallOrigin {
	SIDE_PANEL = 'genie_side_panel',
	PAGE = 'genie',
}

// The in-app support chat of an account (aiChatService `supportChannel`): the Intercom messenger for free and
// trial plans, the Genie side panel for paid ones
export enum SupportChannel {
	GENIE = 'genie',
	INTERCOM = 'intercom',
	NONE = 'none',
}
